<div
  class="sol-checkbox"
  role="checkbox"
  [attr.aria-checked]="value$() === SolCheckboxValue.indeterminate ? 'mixed' : selected$()"
  [attr.aria-disabled]="disabled$() || null"
  [class.sol-checkbox-disabled]="disabled$()"
  [class.sol-checkbox-selected]="selected$()"
  tabindex="0"
  (click)="onClick($event)"
  (keydown.space)="onClick($event)"
  (focus)="onFocused(true)"
  (blur)="onFocused(false)"
  data-shortcut-ignore=" "
  #inputRef
>
  <div
    class="sol-checkbox-icon"
    [class.sol-checkbox-icon-intermediate]="value$() === SolCheckboxValue.indeterminate"
    [class.sol-checkbox-icon-selected]="selected$()"
  >
    @if (selected$()) {
      <div class="sol-checkbox-icon-selected-check"></div>
    }
  </div>

  @if (!!text$()) {
    <div class="sol-checkbox-label">
      {{ text$() }}
      @if (info$()) {
        <div class="sol-checkbox-info">
          {{ info$() | translate }}
        </div>
      }
    </div>
  } @else if (custom$()) {
    <div class="sol-checkbox-label">
      <ng-content />
    </div>
  }
</div>
